import Vue from 'vue';
import Vue2Storage from 'vue2-storage';

Vue.use(Vue2Storage);
export default {
    mutations: {
        setRecoveryData(state, data) {
            if (data.id) state.id = data.id;
            if (data.phone) state.phone = data.phone;
            if (data.verify) state.verify = data.verify;
            if (data.created_at) state.created_at = data.created_at;
        },
        clearRecoveryData(state) {
            state.id = null;
            state.phone = null;
            state.verify = null;
            state.created_at = null;
        }
    },
    state: {
        id: null,
        phone: false,
        verify: null,
        created_at: null,
    },
    getters: {
        getRecoveryData(state) {
            return {
                id: state.id,
                phone: state.phone,
                verify: state.verify,
                created_at: state.created_at,
            }
        }
    }
}